import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import Account from 'components/Admin/WarehoouseAssignment/index';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        {/*<h1>Warehouse</h1>*/}
        <Account />
      </SiteContent>
    </ContentLayout>
  );
};
